import { adminApi, getAccessToken, SUPABASE_URL, SUPABASE_ANON_KEY } from './supabase';
import { fetchEventsWithMetadata } from './events';
import { demoStore, LESSONS_DEMO } from '../lessons/previewStore';

export { LESSONS_DEMO };
export const lessonEvents = () => LESSONS_DEMO ? Promise.resolve(demoStore.events()) : fetchEventsWithMetadata();
export async function submitLessonRequest(values, admin = false) {
  if (LESSONS_DEMO) return demoStore.submit(values, admin);
  const token = admin ? await getAccessToken() : SUPABASE_ANON_KEY;
  const response = await fetch(process.env.REACT_APP_LESSONS_FUNCTION_URL || `${SUPABASE_URL}/functions/v1/lesson-requests`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${token}` },
    body: JSON.stringify({ ...values, admin_entry: admin }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || 'Could not save your request. Please try again.');
  return result;
}
async function allRows(path) {
  const rows = [];
  for (let offset = 0; ; offset += 500) {
    const page = await adminApi(`${path}&limit=500&offset=${offset}`);
    rows.push(...page);
    if (page.length < 500) return rows;
  }
}
export async function loadLessonAdmin() {
  if (LESSONS_DEMO) return demoStore.load();
  const [requests, settings, notifications] = await Promise.all([
    allRows('lesson_requests?select=*&order=created_at.desc,id.desc'),
    allRows('lesson_event_settings?select=*&order=event_key'),
    allRows('lesson_notifications?select=id,request_id,kind,status,last_error,created_at,sent_at&order=created_at,id'),
  ]);
  return { requests, settings, notifications };
}
export async function updateLessonRequest(request, changes) {
  if (LESSONS_DEMO) return demoStore.update(request, changes);
  const rows = await adminApi(`lesson_requests?id=eq.${request.id}&updated_at=eq.${encodeURIComponent(request.updated_at)}`, {
    method: 'PATCH', headers: { Prefer: 'return=representation' }, body: JSON.stringify(changes),
  });
  if (!rows.length) throw new Error('This request was changed elsewhere. Refresh the list before editing again.');
  return rows[0];
}
export async function saveLessonSettings(settings, expectedUpdatedAt = null) {
  if (LESSONS_DEMO) return demoStore.settings(settings, expectedUpdatedAt);
  return adminApi('rpc/save_lesson_event_settings', {
    method: 'POST', body: JSON.stringify({ settings, expected_updated_at: expectedUpdatedAt }),
  });
}
export function lessonHistory(id) {
  if (LESSONS_DEMO) return Promise.resolve(demoStore.history(id));
  return adminApi(`lesson_request_history?request_id=eq.${id}&select=*&order=created_at.desc,id.desc&limit=100`);
}
export async function queueLessonInvitations(settings, recipients) {
  if (LESSONS_DEMO) throw new Error('Email sending is unavailable in the browser-only demo. Use the development or local database preview to test emails.');
  const rows = await adminApi('rpc/queue_lesson_invitations', {
    method: 'POST', body: JSON.stringify({ target_event: settings.event_key, expected_settings_updated_at: settings.updated_at,
      recipients: recipients.map(({ request, host }) => ({ id: request.id, updated_at: request.updated_at, host })) }),
  });
  // Keep the private frozen payload out of frontend state.
  return rows.map(({ id, request_id, kind, status, last_error, created_at, sent_at }) => ({ id, request_id, kind, status, last_error, created_at, sent_at }));
}
